// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1ebed271","977":"1603e098"}[chunkId] + ".chunk.js";
};